import { logEvent } from "AppManager";
import { Device } from "DeviceUtils";
import { Button, ModalHeader } from "LocalGluons";
import CustomScrollviewWithScrollBar from "LocalGluons/components/CustomScrollView/CustomScrollView";
import { t } from "Locale";
import { Text, View } from "react-native";
import styles from './LowLatencyModal.jss';

interface LowLatencyModalProps {
    switchFromLowLatency: () => void;
    onClose: () => void;
}

const LowLatencyModal = ({ switchFromLowLatency, onClose }: LowLatencyModalProps) => {
    const onPress = () => {
        logEvent({
            time: Date.now(),
            type: "user-flow",
            subtype: "low-latency-popup",
            deviceId: "0000",
            deviceType: "OTT_TV_ANDROID",
            clientId: "0000",
            ipaddress: "",
            content1: "close",
            content2: "",
            context: "/player"
        });
        onClose();
    };
    return (
        Device.isTabletOrWeb ?
            <View style={styles.wrapper}>
                <ModalHeader style={styles.header} onPress={onPress} />
                <View style={styles.main}>
                    <View style={styles.container}>
                        <View style={styles.content}>
                            <CustomScrollviewWithScrollBar contentContainerStyle={styles.scrollContent}>
                                <Text style={styles.title}>{t('LOW_LATENCY.CHANNEL_INFO_TITLE_MOBILES')}</Text>
                                <View style={styles.divider}></View>
                                <Text style={styles.description}>{t('LOW_LATENCY.CHANNEL_INFO_DESCRIPTION_MOBILES')}</Text>
                                <View style={styles.buttonsContainer}>
                                    <Button
                                        style={styles.button}
                                        isSecondary
                                        title={t('LOW_LATENCY.SWITCH_TO_CHANNEL_BTN_MOBILES')}
                                        onPress={switchFromLowLatency}
                                        testID="confirm_button"
                                    />
                                    <Button
                                        style={styles.button}
                                        title={t('COMMON.I_UNDERSTAND')}
                                        onPress={onPress}
                                        testID="cancel_button"
                                    />
                                </View>
                            </CustomScrollviewWithScrollBar>
                        </View>
                    </View>
                </View>
            </View> :
            <View style={styles.wrapper}>
                <ModalHeader style={styles.header} onPress={onPress} />
                <View style={styles.main}>
                    <View style={styles.content}>
                        <CustomScrollviewWithScrollBar contentContainerStyle={styles.scrollContent}>
                            <Text style={styles.title}>{t('LOW_LATENCY.CHANNEL_INFO_TITLE_MOBILES')}</Text>
                            <View style={styles.divider}></View>
                            <Text style={styles.description}>{t('LOW_LATENCY.CHANNEL_INFO_DESCRIPTION_MOBILES')}</Text>
                            <View style={styles.buttonsContainer}>
                                <Button
                                    style={styles.button}
                                    isSecondary
                                    title={t('LOW_LATENCY.SWITCH_TO_CHANNEL_BTN_MOBILES')}
                                    onPress={switchFromLowLatency}
                                    testID="confirm_button"
                                />
                                <Button
                                    style={styles.button}
                                    title={t('NOTIFICATION.BTN_1')}
                                    onPress={onPress}
                                    testID="cancel_button"
                                />
                            </View>
                        </CustomScrollviewWithScrollBar>
                    </View>
                </View>
            </View>)
}

export default LowLatencyModal